export default __webpack_public_path__ + "static/media/retractable-roof.9abe731d.jpeg";